import { render, staticRenderFns } from "./InvolvementPlotly.vue?vue&type=template&id=50b41019&"
import script from "./InvolvementPlotly.vue?vue&type=script&lang=js&"
export * from "./InvolvementPlotly.vue?vue&type=script&lang=js&"
import style0 from "./InvolvementPlotly.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports